<template>
    <!--
        $attrs：继承所有的父组件属性(除html属性，props属性外)
        $listeners: 组件上的所有监听器，暴露给父组件调用
        inheritAttrs: false 控制是否继承
        v-model：是v-bind:value 和 v-on:input结合
        适用于包装第三方组件
    -->
    <Modal v-bind="{...$attrs, ...defaultValue}" v-on="$listeners" v-model="visible">
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">  <!-- 作用域插槽 -->
            <slot :name="slot" v-bind="scope"/> <!-- 具名插槽 -->
        </template>
        <slot/> <!-- 默认插槽 -->
    </Modal>
</template>
<script>
    import { Modal } from 'ant-design-vue';

    // 预设参数
    const defaultValue = new Map([
        [1, { width: '1500px', cancelText: '关闭', title: '学习详情' }],
        [2, { cancelText: '关闭', okText: '发送', title: '催办' }],
    ]);

    export default {
        name: 'ComponentsModal',
        components: {
            Modal
        },
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            defaultKey: {
                type: Number,
                default: 1
            },
        },
        computed: {
            defaultValue() {
                return defaultValue.get(this.defaultKey);
            },
            // 进行属性拦截 保证单向数据流
            visible: {
                get() {
                    return this.value;
                },
                set(newVal) {
                    this.$emit('input', newVal);
                }
            }
        }
    };
</script>
